import React from 'react';
import { Check, MessageSquareMore, Rocket } from 'lucide-react';
import { Button } from '@/components/ui/Button';
import Link from 'next/link';
import { useCustomerly } from 'react-live-chat-customerly';

const PricingSection = () => {
  const { showNewMessage: showNewCustomerlyMessage } = useCustomerly();
  return (
    <section id="pricing" className="py-16 px-4 md:px-8 bg-white scroll-mt-12">
      <div className="max-w-xl md:max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-primary mb-6 font-funnel">
            Piani <span className="text-accent">flessibili</span> per ogni esigenza
          </h2>
          <p className="text-lg text-neutral-700">
            Offriamo soluzioni che si adattano a professionisti, studi e aziende di ogni dimensione.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-8 gap-6 lg:gap-8">
          <div
            className={`relative rounded-xl p-6 shadow-md hover:shadow-lg transition duration-200 bg-linear-to-t from-white to-white border border-neutral-200 md:col-span-5`}
          >
            <div className="mb-4">
              <h3 className={`text-2xl font-bold text-center mb-4 text-primary`}>I nostri piani</h3>
              <p className={`text-base text-center text-neutral-600`}>
                Disponibili in vari tagli, a seconda delle tue esigenze.
                <br />
                Scegli tra fatturazione mensile o annuale.
              </p>
            </div>

            <div className="mb-6 text-center">
              <div className={`mb-1 text-sm text-neutral-600`}>A partire da</div>
              <div className="flex items-baseline justify-center">
                <span className={`text-4xl font-bold text-primary`}>€69</span>
                <span className={`ml-1 text-lg text-neutral-600`}>/mese</span>
              </div>
              <div className={`mr-2 text-sm text-success-500`}>
                <div className="mt-2 inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold border-transparent bg-green-600 text-white">
                  <Rocket className="w-3 h-3 mr-1" /> Offerta primo anno
                </div>
              </div>
            </div>

            <p className="text-neutral-700 mb-4">Inclusi in ogni piano:</p>

            <ul className="space-y-2 mb-8">
              {['Tutte le funzionalità di Trovanorma', 'Utenti e dispositivi illimitati'].map(
                (feature, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <Check className={`w-5 h-5 min-w-5 mt-0.5 text-success-500`} />
                    <span className={`text-base text-neutral-700`}>{feature}</span>
                  </li>
                )
              )}
            </ul>

            <Button asChild size="lg" variant="default" className="w-full">
              <Link href={process.env.NEXT_PUBLIC_APP_URL + '/signup'}>Provalo ora</Link>
            </Button>
          </div>

          <div
            className={`relative rounded-xl p-6 duration-200 bg-linear-to-t bg-neutral-50 border border-neutral-200 text-center md:col-span-3`}
          >
            <div className="mb-4">
              <h3 className={`text-2xl font-bold text-center mb-4 text-primary`}>
                Domande o dubbi?
              </h3>
              <p className={`text-base text-center text-neutral-600 mb-4`}>
                Siamo a tua disposizione.
              </p>
              <p className={`text-base text-center text-neutral-600`}>
                Contattaci senza impegno per una soluzione personalizzata su misura per il tuo
                studio o la tua azienda.
              </p>
            </div>

            <div className="md:absolute bottom-6 left-6 right-6">
              <Button
                size="lg"
                variant="outline"
                className="w-full"
                onClick={() => showNewCustomerlyMessage('')}
              >
                <MessageSquareMore className="w-5 h-5 mr-2" />
                Contattaci
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PricingSection;
